'use strict';

let module = angular.module('doclr.components.agenda');

module.factory('localStorageService', function (userContext, praktijkContext, $window, sortByProperty) {

    function createKeyName(keyName) {
        return praktijkContext.id + "_" + userContext.username + "_" + keyName;
    }

    function getItem(keyName) {
        try {
            if ($window.localStorage[createKeyName(keyName)] != undefined) {
                return JSON.parse($window.localStorage[createKeyName(keyName)]);
            } else {
                return undefined;
            }
        } catch (ex) {
            doclrStaticUtils.debug(ex);
            return undefined
        }
    }

    function storeItem(keyName, value) {
        try {
            $window.localStorage[createKeyName(keyName)] = JSON.stringify(value);
        } catch (ex) {
            doclrStaticUtils.debug(ex);
        }
    }

    function clearStorage() {
        try {
            $window.localStorage.clear();
        } catch (ex) {
            doclrStaticUtils.debug(ex);
        }
    }

    function clearItem(keyName) {
        try {
            $window.localStorage.removeItem(createKeyName(keyName));
        } catch (ex) {
            doclrStaticUtils.debug(ex);
        }
    }

    function sortTypesByLocalStorage(types, sortType, calendarId) {
        try {
            if (!calendarId) {
                return types;
            }

            let storedList = getItem("sort_" + sortType + "_" + calendarId);
            let lastSelect = getItem("last_select_" + sortType + "_" + calendarId);

            if (!storedList) {
                tryClearForSort(sortType, calendarId);
                return types
            }

            let lastStored = [];
            let itemsStored = [];
            let itemsNotStored = [];

            for (let i = 0; i < types.length; i++) {
                let item = types[i];
                let id = doclrStaticUtils.getUUIDFromObjectWithId(item);
                let storedNb = storedList[id];
                if (lastSelect && lastSelect === id) {
                    lastStored.push(item);
                } else {
                    if (storedNb) {
                        itemsStored.push({
                            id: id,
                            nb: storedNb,
                            item: item
                        })
                    } else {
                        itemsNotStored.push(item);
                    }
                }

            }

            let sortedStoredItems = itemsStored.sort(sortByProperty(x => x.nb))
                .map(x => x.item);

            return [...lastStored, ...sortedStoredItems, ...itemsNotStored];


        } catch (ex) {
            tryClearForSort(sortType, calendarId);
            return types;
        }
    }

    function addSortTypeByLocalStorage(type, sortType, calendarId) {
        try {
            let typeId = doclrStaticUtils.getUUIDFromObjectWithId(type);

            if (!calendarId || !typeId) {
                return;
            }

            storeItem("last_select_" + sortType + "_" + calendarId, typeId);

            let storedList = getItem("sort_" + sortType + "_" + calendarId);

            if (!storedList) {
                storedList = {};
            }

            let itemNbr = storedList[typeId];
            if (itemNbr) {
                storedList[typeId] = itemNbr + 1;
            } else {
                storedList[typeId] = 1;
            }
            storeItem("sort_" + sortType + "_" + calendarId, storedList);
        } catch (ex) {
            doclrStaticUtils.debug(ex);
            tryClearForSort(sortType, calendarId);
        }
    }

    function tryClearForSort(sortType, calendarId) {
        try {

            if (!calendarId) {
                return;
            }

            clearItem("sort_" + sortType + "_" + calendarId);
            clearItem("last_select" + sortType + "_" + calendarId);
        } catch (ex) {
            doclrStaticUtils.debug(ex);
        }
    }

    return {
        getItem: getItem,
        storeItem: storeItem,
        clearItem: clearItem,
        sortTypesByLocalStorage: sortTypesByLocalStorage,
        addSortTypeByLocalStorage: addSortTypeByLocalStorage,
        clearStorage: clearStorage,
        keys: {
            selectedResources: 'selectedResources',
            selectedCalendars: 'selectedCalendars'
        }
    }

});

module.config(function ($stateProvider) {
    $stateProvider.state('cs', {
            url: '/cs',
            template: '<div></div>',
            controller: function ($location, localStorageService) {
                localStorageService.clearStorage();
                $location.path('/agenda');
            }
        }
    )
});

module.factory('moveService', function (notificationService) {
    var afspraak = null;
    var target = null;
    var selectedType = null;
    var selectedDuur = null;
    var startMovingListener = function () {
    };
    var stopMovingListener = function () {
    };
    var copy = false;

    return {
        start: function (afspraakToMove, makeCopy) {
            // DOCLEAS-042: a participant row (colleague / resource copy) can only be moved via its
            // hoofdafspraak. The backend rejects it anyway; stop it here so nothing half-happens.
            if (afspraakToMove && afspraakToMove.participantRole && afspraakToMove.participantRole !== 'OWNER') {
                notificationService.showDanger('Deze afspraak kan enkel verplaatst of gekopieerd worden via de hoofdafspraak.');
                return;
            }
            copy = makeCopy;
            afspraak = afspraakToMove;
            target = null;
            startMovingListener(afspraakToMove);
        },
        cancel: function () {
            copy = false;
            afspraak = null;
            target = null;
            stopMovingListener();
        },
        setTarget: function (newTarget) {
            selectedType = null;
            selectedDuur = null;
            target = {
                dag: newTarget.dag,
                van: newTarget.van,
                tot: newTarget.tot,
                duur: newTarget.tot ? moment(newTarget.tot, 'HH:mm').diff(moment(newTarget.van, 'HH:mm'), 'minutes') : null,
                agendaId: newTarget.agendaId,
                typeId: newTarget.typeId,
                type: newTarget.type
            };
        },
        isMoving: function () {
            return afspraak !== null;
        },
        // DOCLEAS-034: a hoofdafspraak with colleague rows stays in its own calendar when it is moved
        // (the colleague rows keep theirs). Making a copy elsewhere is fine.
        isTargetCalendarAllowed: function (targetAgendaId) {
            if (!afspraak || copy || !afspraak.heeftDeelnemers) {
                return true;
            }
            return doclrStaticUtils.getUUIDFromUrl(targetAgendaId) === doclrStaticUtils.getUUIDFromUrl(afspraak.agendaId);
        },
        targetCalendarNotAllowedMessage: 'Een afspraak met deelnames kan enkel binnen dezelfde agenda verplaatst worden. Pas de agenda\'s van de afspraak aan of maak een kopie.',
        isMakingCopy: function () {
            return copy;
        },
        isMovingToSlice: function (slice) {
            return this.hasTarget() && slice.dag === target.dag && slice.id === target.agendaId;
        },
        hasAfspraak: function () {
            return afspraak !== null;
        },
        getAfspraak: function () {
            return afspraak;
        },
        hasTarget: function () {
            return target !== null;
        },
        getTarget: function () {
            return target;
        },
        setTargetType: function () {
            selectedType = target.typeId;
        },
        setAfspraakType: function () {
            selectedType = afspraak.typeId;
        },
        canMove: function () {
            return this.isMoving() && this.hasTarget();
        },
        getSelectedType: function () {
            return selectedType || afspraak.typeId;
        },

        isTargetTypeSelected: function () {
            return this.hasTarget() && this.getSelectedType() === target.typeId;
        },
        isAfspraakTypeSelected: function () {
            return this.hasAfspraak() && this.getSelectedType() === afspraak.typeId;
        },
        isAfspraakTypeDifferentFromTargetType: function () {
            return target.typeId && (target.typeId !== afspraak.typeId);
        },

        getSelectedDuur: function () {
            return selectedDuur || afspraak.duur;
        },
        setTargetDuur: function () {
            selectedDuur = target.duur;
        },
        setAfspraakDuur: function () {
            selectedDuur = afspraak.duur;
        },
        isTargetDuurSelected: function () {
            return this.hasTarget() && this.getSelectedDuur() === target.duur;
        },
        isAfspraakDuurSelected: function () {
            return this.hasAfspraak() && this.getSelectedDuur() === afspraak.duur;
        },
        isAfspraakDuurDifferentFromTargetDuur: function () {
            return target.duur && (target.duur !== afspraak.duur);
        },
        doMove: function () {
            var that = this;
            target.typeId = this.getSelectedType();
            target.duur = this.getSelectedDuur();
            target.tot = moment(target.van, 'HH:mm').add(target.duur, 'minutes').format('HH:mm');
            if (copy) {
                return afspraak.kopieer(target).then(function (nieuweAfspraak) {
                    that.cancel();
                    return nieuweAfspraak;
                });
            } else {
                return afspraak.verplaats(target).then(function (nieuweAfspraak) {
                    that.cancel();
                    return nieuweAfspraak;
                });
            }
        },
        registerStartMovingListener: function (listener) {
            startMovingListener = listener;
        },
        registerStopMovingListener: function (listener) {
            stopMovingListener = listener;
        }
    };
});

module.factory('agendaContextService', function () {
    var defaultProfile, activeProfile;

    var createProfile = function (options) {
        return {
            clickedInSliceListener: options.clickedInSliceListener || function () {
            },
            clickedOnEventListener: options.clickedOnEventListener || function () {
            },
            dblClickedOnEventListener: options.dblClickedOnEventListener || function () {
            },
            eventInFocus: options.eventInFocus,
            maskOnHover: options.maskOnHover || false
        };
    };

    defaultProfile = createProfile({});
    activeProfile = defaultProfile;

    var result = {
        getDefaultProfile: function () {
            return defaultProfile;
        },
        activateProfile: function (options) {
            activeProfile = createProfile(options);
        },
        restoreDefaultProfile: function () {
            activeProfile = defaultProfile;
        },
        getActiveProfile: function () {
            return activeProfile;
        },
        clickedInSlice: function (slice, uur, $event) {
            activeProfile.clickedInSliceListener(slice, uur, $event);
        },
        clickedOnEvent: function (event, $event) {
            activeProfile.clickedOnEventListener(event, $event);
        },
        dblClickedOnEvent: function (event, $event) {
            activeProfile.dblClickedOnEventListener(event, $event);
        },
        isEventInFocus: function (event) {
            return activeProfile.eventInFocus && activeProfile.eventInFocus.id === event.id;
        }
    };
    return result;
});

module.factory('TimeChangedNotifier', function (repeater) {
    return function (scope) {
        var timeChangedListeners = [];
        var timeChangedRepeater = repeater.repeat(function () {
            var now = moment();
            angular.forEach(timeChangedListeners, function (timeChangedListener) {
                timeChangedListener(now);
            });
        })
            .setImmediate(true)
            .limitTo(scope)
            .setInterval(30000);

        var addTimeChangedListener = function (scope, listener) {
            timeChangedListeners.push(listener);
            timeChangedRepeater.restart();

            scope.$on('$destroy', function () {
                timeChangedListeners.splice(timeChangedListeners.indexOf(listener), 1);
            });
        };

        return {
            addTimeChangedListener: addTimeChangedListener
        };
    };
});

module.factory('slicesService', function (slicesLoaderFactory) {
    return {
        slicesLoaderHolder: {},
        slicesLoader: null,
        load: function (criteria) {
            this.slicesLoader = slicesLoaderFactory();
            this.slicesLoaderHolder.slicesLoader = this.slicesLoader;
            return this.slicesLoader.load(criteria);
        },
        reload: function () {
            return this.slicesLoader.reload();
        }
    };
});

module.factory('slicesLoaderFactory', function (Legende, Agendas, $state, $rootScope, $timeout, userContext, beschikbaarheidTypesCache, appContext) {
    return function slicesLoaderFactory() {

        function load(newCriteria) {

            var slicesPromise;
            var previousCriteria = loader.criteria;

            function getUitgeslotenDagen(agenda) {
                var uitgeslotenDagen = [];

                if (!agenda.dagTonenInAgendaMaandag) {
                    uitgeslotenDagen.push(1);
                }
                if (!agenda.dagTonenInAgendaDinsdag) {
                    uitgeslotenDagen.push(2);
                }
                if (!agenda.dagTonenInAgendaWoensdag) {
                    uitgeslotenDagen.push(3);
                }
                if (!agenda.dagTonenInAgendaDonderdag) {
                    uitgeslotenDagen.push(4);
                }
                if (!agenda.dagTonenInAgendaVrijdag) {
                    uitgeslotenDagen.push(5);
                }
                if (!agenda.dagTonenInAgendaZaterdag) {
                    uitgeslotenDagen.push(6);
                }
                if (!agenda.dagTonenInAgendaZondag) {
                    uitgeslotenDagen.push(7);
                }

                return uitgeslotenDagen;
            }

            loader.criteria = newCriteria;

            function inflate(newSlices) {

                for (let i = 0; i < newSlices.length; i++) {
                    for (let j = 0; j < newSlices[i].events.length; j++) {
                        let event = newSlices[i].events[j];
                        event.subEvents = [];
                        event.statusInfo = getStatusInfo(event);
                        updateColor(event);
                        if (event.parentBeschikbaarheid) {
                            let multiplicity = event.parentBeschikbaarheid.beschikbaarheidRelation.multiplicity;
                            if (event.parentBeschikbaarheid.multiplicity) {
                                multiplicity = event.parentBeschikbaarheid.multiplicity;
                            }

                            for (let k = 1; k < multiplicity; k++) {
                                event.subEvents.push(k);
                            }
                        }
                    }
                }

                if (previousCriteria !== null &&
                    previousCriteria.modus === newCriteria.modus &&
                    previousCriteria.discipline === newCriteria.discipline &&
                    previousCriteria.agendaOrResource === newCriteria.agendaOrResource &&
                    (!loader.sliceHolders || !newSlices || loader.sliceHolders.length === newSlices.length) //Agenda kan verwijderd zijn, dan moet het raster opnieuw worden getekend
                ) {
                    for (var i = 0; i < newSlices.length; i++) {
                        loader.sliceHolders[i].slice = newSlices[i];
                    }
                } else {
                    loader.sliceHolders = _.map(newSlices, function (slice) {
                        return {slice: slice};
                    });
                }

                loader.sliceHolders.forEach(holder => {
                    if (holder.slice.verlofdagnaam && userContext.holidayVisible) {
                        holder.slice.dayInfo = doclrVertaal.instant("holiday." + holder.slice.verlofdagnaam.toLowerCase().replaceAll(" ", ""));
                    } else {
                        if (userContext.vacationVisible) {
                            holder.slice.dayInfo = holder.slice.vacationPeriod ? doclrVertaal.translateProperty(holder.slice.vacationPeriod, 'name') : '';
                        }
                    }
                });

                loader.hasDayInfo = loader.sliceHolders.filter(holder => holder.slice.dayInfo !== '').length > 0;

                loader.slices = newSlices;
                loader.legende = Legende.soortenAfpsraakMogelijkhedenVoor(newSlices);
            }

            if (newCriteria.modus === 'dag') {
                slicesPromise = Agendas.eventsVoorPraktijk(newCriteria.praktijkId, newCriteria.dag, newCriteria.discipline, newCriteria.agendas, newCriteria.resources);
                newCriteria.exportAgenda = function (extention) {
                    return Agendas.agendaExportVoorPraktijk(extention, newCriteria.praktijkId, newCriteria.dag, newCriteria.discipline, newCriteria.agendas, newCriteria.resources);
                };
            } else if (newCriteria.modus === 'week') {
                slicesPromise = Agendas.eventsVoorAgenda(newCriteria.agendaOrResource.id, newCriteria.van, newCriteria.tot, getUitgeslotenDagen(newCriteria.agendaOrResource));
                newCriteria.exportAgenda = function (extention) {
                    return Agendas.agendaExportVoorAgenda(extention, newCriteria.agendaOrResource.id, newCriteria.van, newCriteria.tot, getUitgeslotenDagen(newCriteria.agendaOrResource));
                };
            } else if (newCriteria.modus === 'dashboard') {
                slicesPromise = Agendas.eventsVoorAgenda(newCriteria.agenda.id, newCriteria.dag, newCriteria.dag, getUitgeslotenDagen(newCriteria.agenda));
                newCriteria.exportAgenda = function (extention) {
                    return Agendas.agendaExportVoorAgenda(extention, newCriteria.agenda.id, newCriteria.dag, newCriteria.dag, getUitgeslotenDagen(newCriteria.agenda));
                };
            }

            slicesPromise.then(function (slices) {
                inflate(slices);
                $rootScope.$broadcast('slicesLoaded');
                return loader;
            });

            return slicesPromise;
        }

        function updateColor(event) {
            if (!appContext.brandingSettings.calendarShowColorOfProduct) {
                return;
            }
            if (!event.customForm ||
                !event.customForm.activities ||
                event.customForm.activities.length === 0 ||
                !event.customForm.activities[0].id) {
                return;
            }

            const productId = event.customForm.activities[0].id;
            const productsForActivity = beschikbaarheidTypesCache.filter(x => x.id === productId && x.kleur);

            if (productsForActivity.length > 0) {
                event.kleur = productsForActivity[0].kleur;
            }
        }

        function getStatusInfo(event) {

            if (event.statusNoShowOn) {
                return {
                    color: 'var(--doclr-color-red)',
                    lettre: 'N',
                    title: 'No show'
                }
            }

            if (event.statusEndedOn) {
                return {
                    color: 'var(--doclr-color-green)',
                    lettre: 'E',
                    title: 'Geëindigd'
                }
            }

            if (event.statusStartedOn) {
                return {
                    color: 'var(--doclr-color-yellow)',
                    lettre: 'S',
                    title: 'Gestart'
                }
            }

            if (event.statusArrivedOn) {
                return {
                    color: 'var(--doclr-color-blue)',
                    lettre: 'A',
                    title: 'Aanwezig'
                }
            }
            return undefined;
        }


        function highlightEvent(promise, eventId) {
            if (eventId) {
                promise.then(function () {
                    $timeout(function () {
                        $rootScope.$broadcast('highlightEvent', eventId);
                    }, 300);
                });
            }
        }

        var navigator = {

            wijzigDagEnAgenda: function (dag, agendaId, eventId) {
                var promise;

                if (loader.criteria.kanNaarAgendaNavigeren(agendaId)) {
                    promise = loader.load(loader.criteria.wijzigDagEnAgenda(dag, agendaId));
                } else {
                    promise = $state.go('agenda.initial', {dag: dag});
                }

                highlightEvent(promise, eventId);

                return promise;
            },

            wijzigDag: function (dag, eventId) {
                const promise = loader.load(loader.criteria.wijzigDag(dag));
                highlightEvent(promise, eventId);
                return promise;

            },

            naarWeekModus: function (agendaId) {
                loader.load(loader.criteria.naarWeekModus(agendaId));
            },

            selecteerAgenda: function (agenda) {
                loader.load(loader.criteria.selecteerAgenda(agenda));
            },

            selecteerAgendas: function (agendas) {
                if (agendas.length === 1) {
                    loader.load(loader.criteria.selecteerAgenda(agendas[0]));
                }
                loader.load(loader.criteria.selecteerAgendas(agendas));
            },

            selecteerAlleenAgenda: function (agendaId) {
                loader.load(loader.criteria.naarWeekModus(agendaId));
            },

            selecteerResource: function (resource) {
                loader.load(loader.criteria.selecteerResource(resource));
            },

            selecteerAgendasEnResources: function (agendaIds, resourceIds) {
                loader.load(loader.criteria.selecteerAgendasEnResources(agendaIds, resourceIds));
            },

            naarDagModus: function (dag, discipline, eventId) {
                const promise = loader.load(loader.criteria.naarDagModus(dag, discipline));
                highlightEvent(promise, eventId);
                return promise;
            },

            isSelected: function (agenda) {
                return loader.criteria.isSelected(agenda.id);
            }
        };

        var loader = {
            load: load,
            reload: function () {
                return load(loader.criteria);
            },
            criteria: null,
            slices: null,
            sliceHolders: [],
            legende: [],
            navigator: navigator
        };

        return loader;
    };
});

module.factory('agendaCriteriaFactory', function (agendaBoundaries, localStorageService) {
    return function (praktijkId, agendas, resources, dag) {

        let lastViewStateStorageKey = "lastViewState";

        function createDagCriteria(dag, discipline, agendaIds, resourceIds) {
            const calendarUuids = (agendaIds || []).map(id => id.split('/').pop());
            const resourceUuids = (resourceIds || []).map(id => id.split('/').pop());
            const current = localStorageService.getItem(lastViewStateStorageKey) || {};
            localStorageService.storeItem(lastViewStateStorageKey, {
                ...current,
                calendarIds: calendarUuids,
                resourceIds: resourceUuids
            });

            return {
                modus: 'dag',
                dag: dag,
                praktijkId: praktijkId,
                discipline: discipline,
                agendas: agendaIds || [],
                resources: resourceIds || [],

                wijzigDagEnAgenda: function (dag, agendaId) {
                    if (this.agendas && this.agendas.length > 0 && agendaId && this.agendas.filter(x => x === agendaId).length === 0) {
                        return this.selecteerAgenda(agendaId)
                            .wijzigDag(dag);
                    } else {
                        return this.wijzigDag(dag);
                    }
                },

                wijzigDag: function (dag) {
                    return createDagCriteria(dag, discipline, this.agendas, this.resources);
                },

                naarWeekModus: function (agendaId) {
                    return createWeekCriteria(dag, agendaId);
                },

                naarDagModus: function (nieuweDag, discipline) {
                    return createDagCriteria((nieuweDag || dag), discipline);
                },

                selecteerAgenda(agendaId) {
                    if (this.agendas.length + this.resources.length === 0) {
                        return this.naarWeekModus(agendaId);
                    }
                    if (this.agendas.indexOf(agendaId) > -1) {
                        if (this.agendas.length + this.resources.length === 1) {
                            return;
                        }

                        const calendarsWithoutClicked = this.agendas.filter(x => x !== agendaId);

                        if (calendarsWithoutClicked.length + this.resources.length === 1) {
                            if (calendarsWithoutClicked.length === 1) {
                                return this.naarWeekModus(calendarsWithoutClicked[0]);
                            } else {
                                return this.naarWeekModus(this.resources[0]);
                            }
                        }
                        return createDagCriteria(dag, undefined, calendarsWithoutClicked, this.resources);
                    }
                    return createDagCriteria(dag, undefined, [...this.agendas, agendaId], this.resources);
                },

                selecteerAgendas(agendaIds) {
                    return createDagCriteria(dag, undefined, agendaIds, this.resources);
                },

                selecteerAgendasEnResources(agendaIds, resourceIds) {
                    return createDagCriteria(dag, undefined, agendaIds, resourceIds);
                },

                selecteerResource(resourceId) {
                    if (this.agendas.length + this.resources.length === 0) {
                        return this.naarWeekModus(resourceId);
                    }

                    if (this.resources.indexOf(resourceId) > -1) {
                        if (this.agendas.length + this.resources.length === 1) {
                            return;
                        }

                        const resourcesWithoutClicked = this.resources.filter(x => x !== resourceId);

                        if (this.agendas.length + resourcesWithoutClicked.length === 1) {
                            if (this.agendas.length === 1) {
                                return this.naarWeekModus(this.agendas[0]);
                            } else {
                                return this.naarWeekModus(resourcesWithoutClicked[0]);
                            }
                        }
                        return createDagCriteria(dag, undefined, this.agendas, resourcesWithoutClicked);
                    }

                    return createDagCriteria(dag, undefined, this.agendas, [...this.resources, resourceId]);
                },

                isSelected: function (agendaOrResourceId) {
                    return false //  return this.agendaOrResourceId === agendaOrResourceId;
                },


                kanNaarAgendaNavigeren: function () {
                    return true;
                },
            };
        }

        function createWeekCriteria(dag, agendaOrResourceId) {

            agendaOrResourceId = agendaOrResourceId || agendas[0].id;
            let isResource = agendaOrResourceId.indexOf('resource') >= 0;

            let agendaOrResource = isResource ?
                resources.findResourceVoorId(agendaOrResourceId) :
                agendas.findAgendaVoorId(agendaOrResourceId);

            const uuid = agendaOrResourceId.split('/').pop();
            const current = localStorageService.getItem(lastViewStateStorageKey) || {};
            localStorageService.storeItem(lastViewStateStorageKey, {
                ...current,
                calendarIds: isResource ? [] : [uuid],
                resourceIds: isResource ? [uuid] : []
            });

            function berekenTeTonenDagInDagModus(van) {
                if (moment(van).isBefore(moment(agendaBoundaries.minDate), 'day')) {
                    return moment(agendaBoundaries.minDate).format('YYYY-MM-DD');
                } else if (moment(van).isSame(moment(), 'week')) {
                    return moment().format('YYYY-MM-DD');
                } else {
                    return van;
                }
            }


            return {
                modus: 'week',
                van: moment(dag).weekday(0).format('YYYY-MM-DD'),
                tot: moment(dag).weekday(6).format('YYYY-MM-DD'),
                dag: moment(dag).weekday(0).format('YYYY-MM-DD'),
                agendaOrResource: agendaOrResource,
                agendaOrResourceId: agendaOrResourceId,
                agendas: isResource ? [] : [agendaOrResourceId],
                resources: isResource ? [agendaOrResourceId] : [],

                wijzigDagEnAgenda: function (dag, agendaId) {
                    return createWeekCriteria(dag, agendaId);
                },

                wijzigDag: function (dag) {
                    return createWeekCriteria(dag, agendaOrResourceId);
                },

                naarWeekModus: function (agendaOrResourceId) {
                    return createWeekCriteria(dag, agendaOrResourceId);
                },

                naarDagModus: function (dag) {
                    return createDagCriteria(dag || berekenTeTonenDagInDagModus(this.van));
                },

                selecteerAgenda(agendaId) {
                    return createDagCriteria(dag, undefined, [...this.agendas, agendaId], this.resources);
                },

                selecteerAgendas(agendaIds) {
                    return createDagCriteria(dag, undefined, agendaIds, this.resources);
                },

                selecteerAgendasEnResources(agendaIds, resourceIds) {
                    return createDagCriteria(dag, undefined, agendaIds, resourceIds);
                },

                selecteerResource(resourceId) {
                    return createDagCriteria(dag, undefined, this.agendas, [...this.resources, resourceId]);
                },

                isSelected: function (agendaOrResourceId) {
                    return this.agendaOrResourceId === agendaOrResourceId;
                },

                kanNaarAgendaNavigeren: function () {
                    return true;
                }
            };
        }

        dag = dag || moment().format('YYYY-MM-DD');

        let existingCalendarsAndResourcesIds = [...agendas, ...resources]
            .map(x => x.id);

        const lastViewState = localStorageService.getItem(lastViewStateStorageKey) || {};

        let selectedCalendars = (lastViewState.calendarIds || [])
            .map(uuid => agendas.findAgendaVoorId('/apiv0/agenda/' + uuid))
            .filter(a => !!a)
            .map(a => a.id);

        let selectedResources = (lastViewState.resourceIds || [])
            .map(uuid => resources.findResourceVoorId('/apiv0/resource/' + uuid))
            .filter(r => !!r)
            .map(r => r.id);

        const combined = [...selectedResources, ...selectedCalendars].filter(x => !!x);

        if (combined.length > 0) {
            if (combined.length === 1) {
                return createWeekCriteria(dag, combined[0]);
            }
            return createDagCriteria(dag, undefined, selectedCalendars, selectedResources);
        } else {
            if (agendas.length === 0) {
                return createDagCriteria(dag);
            }
            if (agendas.length > 1) {
                return createDagCriteria(dag);
            }
            return createWeekCriteria(dag, agendas[0].id);
        }
    };
});

module.factory('agendaDashboardCriteriaFactory', function () {
    return function (agendas, originalAgendaId) {
        var createDashboardCriteria = function (dag, agendaId) {
            agendaId = agendaId ? agendaId : originalAgendaId;
            return {
                modus: 'dashboard',
                dag: dag,
                agenda: agendas.findAgendaVoorId(agendaId),

                wijzigDag: function (dag) {
                    return createDashboardCriteria(dag, agendaId);
                },


                wijzigDagEnAgenda: function (dag, agendaId) {
                    dag = dag ? dag : this.dag;
                    return createDashboardCriteria(dag, agendaId);
                },

                kanNaarAgendaNavigeren: function () {
                    return true; //todo check  agendaId === doelAgendaId;
                }
            };
        };

        return createDashboardCriteria(moment().format('YYYY-MM-DD'));
    };
});

module.factory('agendaDimensions', function (praktijkContext) {
    var minutenTussenLijnen = praktijkContext.minutenTussenLijnen;
    var hourDivisions = _.range(0, 60, minutenTussenLijnen);

    var mobiel = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    var uurhoogte = mobiel ? praktijkContext.uurHoogteMobiel : praktijkContext.uurHoogte;

    return {
        uurHoogte: uurhoogte,
        minuutHoogte: uurhoogte / 60,
        hourDivisions: hourDivisions
    };
});

module.factory('rasterService', function (agendaDimensions, slicesService) {
    function hhMM(hhmm) {
        var split = hhmm.split(':');
        return {
            uren: parseInt(split[0], 10),
            minuten: parseInt(split[1], 10),
            urenRoundedUp: function () {
                return this.minuten > 0 ? this.uren + 1 : this.uren;
            }
        };
    }

    function isHeleDag(event) {
        return event.heleDag ||
            event.van === '00:00' &&
            event.tot === '24:00';
    }

    return {
        showEarlyHours: false,
        showLateHours: false,
        isHover: false,

        toggleShowEarlyHours: function () {
            this.showEarlyHours = !this.showEarlyHours;
        },
        toggleShowLateHours: function () {
            this.showLateHours = !this.showLateHours;
        },

        setIsHover: function (isHover) {
            this.isHover = isHover;
        },

        calculateTop: function (event) {
            if (isHeleDag(event) || event.van === '00:00') {
                return 0;
            }
            var urenEnMinuten = hhMM(event.van);
            return this.calculateTopPixels(urenEnMinuten.uren, urenEnMinuten.minuten);
        },

        calculateTopPixels: function (uren, minuten) {
            return (uren - this.getStartUur()) * agendaDimensions.uurHoogte + (agendaDimensions.minuutHoogte * minuten);
        },
        getHeight: function (event) {
            if (isHeleDag(event)) {
                return (this.getEindUur() - this.getStartUur()) * agendaDimensions.uurHoogte;
            }
            if (event.van === '00:00') {
                if (!this.showEarlyHours) {
                    let height = (agendaDimensions.minuutHoogte * event.duur) - (this.getStartUur() * agendaDimensions.uurHoogte);
                    if (height > 0) {
                        return height;
                    }
                }
            }

            if (event.tot === "24:00") {
                if (!this.showLateHours) {
                    let height = (agendaDimensions.minuutHoogte * event.duur) - ((24 - this.getEindUur()) * agendaDimensions.uurHoogte);
                    if (height > 0) {
                        return height;
                    }
                }
            }
            return agendaDimensions.minuutHoogte * event.duur;
        },
        getStartUur: function () {
            if (this.showEarlyHours) {
                return 0;
            }
            var min = _.chain(this.getSlicesWithEventsOrAllSlices())
                .filter()
                .pluck('van').map(function (van) {
                    return hhMM(van).urenRoundedUp();
                }).min().value();
            return min > 0 ? min - 1 : min;
        },
        getEindUur: function () {
            if (this.showLateHours) {
                return 24;
            }
            var max = _.chain(this.getSlicesWithEventsOrAllSlices()).pluck('tot').map(function (tot) {
                return hhMM(tot).urenRoundedUp();
            }).max().value();
            return max < 24 ? max + 1 : max;
        },
        getSlicesWithEventsOrAllSlices: function () {
            var slices = slicesService.slicesLoader.slices;
            var filtered = slices.filter(function (slice) {
                return slice.events.some(function (x) {
                    return !x.heleDag && x.van !== '00:00' && x.tot !== '24:00';
                });
            });
            return filtered.length > 0 ? filtered : slices;
        }
    };
});

module.factory('openAppointmentService', function (DoclrHttp, praktijkContext, AppConfigService, slicesService, AppointmentPopup, $rootScope) {
    function openAppointment(appointmentId, openPopup) {
        var url = AppConfigService.getApiUrl() + '/api/calendar/v1/party/' + praktijkContext.id + '/appointment/' + appointmentId;
        DoclrHttp.get(url).then(function (appointment) {
            var calendarId = '/apiv0/party/' + praktijkContext.id + '/agenda/' + appointment.calendarId;
            slicesService.slicesLoader.navigator.wijzigDagEnAgenda(appointment.day, calendarId, appointmentId);
            if (openPopup) {
                var deregister = $rootScope.$on('highlightEvent', function () {
                    deregister();
                    var event = {
                        id: appointmentId,
                        van: appointment.van,
                        tot: appointment.tot,
                        voornaam: appointment.voornaam,
                        achternaam: appointment.achternaam,
                        kleur: null
                    };
                    AppointmentPopup.openAppointmentPopup(appointmentId, event);
                });
            }
        });
    }

    return {openAppointment};
});